import React from 'react'

import TextButton from 'LuxKit/Button/TextButton'
import FooterWithCreateUpdateInfo from 'tripPlanner/components/TripModal/Common/FooterWithCreateUpdateInfo'
import EditTripItem from 'tripPlanner/components/TripModal/TripItems/Edit'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
}

export default function EditableItemFooter({ item }: Props) {
  const openModal = useOpenModal()

  return (
    <FooterWithCreateUpdateInfo item={item}>
      <TextButton
        kind="secondary"
        size="large"
        onClick={() => openModal(EditTripItem, { item })}
      >
        Edit
      </TextButton>
    </FooterWithCreateUpdateInfo>
  )
}
